import React from "react";
import styled from "styled-components";
import { useDispatch } from "react-redux";
import { getLookingLoadInfoAdmin } from "../../features/admin5/admin5Slice";
import { showModal } from "../../features/modal/modalSlice";
import { MdOutlineMoreHoriz } from "react-icons/md";

const Container = styled.div`
  width: 100%;
  cursor: pointer;

    .main {
      width: 100%;
      padding: 15px 10px;
      border-radius: 10px;
      position: relative;
      background-color: ${({ theme, sended }) => sended ? "#9ded9a" : theme.secondaryBgColor};
      margin: 0;
      .row {
        width: 100%;
        display: grid;
        grid-template-columns: repeat(9, 1fr);
        text-align: center;
        gap: 15px;
        position: relative;
        .col {
          font-size: var(--font-size-sm);
          font-weight: var(--font-weight-sm);
        }
        .more{
          position: absolute;
          right: 0;
          cursor: pointer;
        }
      }
      
    }
`;

const AdminYukAriyorumContainer = ({ data }) => {
  const dispatch = useDispatch();

  return (
    <Container sended={data.isLoadSended}>
      <div className="main">
        <div className="row">
          <div className="col">{data.phoneNumber}</div>
          <div className="col">{data.userName}</div>
          <div className="col">{data.nerden}</div>
          <div className="col">{data.nereye}</div>
          <div className="col">{data.yukunTasinabilecegiTarih}</div>
          <div className="col">{data.isParsiyel ? "Parsiyel" : ""}</div>
          <div className="col">{data.isKomple ? "Komple Yük" : ""}</div>
          <div className="col">{data.status ? "Aktif" : "Pasif"}</div>
          <div className="col">{data.isLoadSended ? "Gönderildi" : "Gönderilmedi"}</div>
          <div onClick={() => {dispatch(getLookingLoadInfoAdmin(data.userId)); dispatch(showModal("adminYukAriyorum"))}} className="more">
            <MdOutlineMoreHoriz size={20} />
          </div>
        </div>
      </div>
    </Container>
  );
};

export default AdminYukAriyorumContainer;
